import React from 'react';

export const AddBtn = (props) => {
    return(
        <button 
            onClick={props.onClick} 
            className={`AddBtn ${props.className !== undefined ? props.className : null}`}

            style={props.style !== undefined ? props.style :  null}
            >
            <i className="far fa-plus" aria-hidden="true" ></i>
        </button>
    )
} 

export const RemoveBtn = (props) => {
    return(
        <button 
            onClick={props.onClick} 
            className={`RemoveBtn ${props.className !== undefined ? props.className : null}`}
            style={props.style !== undefined ? props.style :  null}
            >
                <i className="far fa-trash" aria-hidden="true"></i>
        </button>
    )
} 

export const BanBtn = (props) => {
    return(
        <button 
            onClick={props.onClick} 
            className={`banBtn ${props.className !== undefined ? props.className : null}`}
            style={props.style !== undefined ? props.style :  null}
            >
                <i className="fad fa-ban" aria-hidden="true"></i>
        </button>
    )
} 

export const UnBanBtn = (props) => {
    return(
        <button 
            onClick={props.onClick} 
            className={`unBanBtn ${props.className !== undefined ? props.className : null}`}
            style={props.style !== undefined ? props.style :  null}
            >
                <i className="fas fa-check" aria-hidden="true"></i>
        </button>
    )
}

